import { CatalogueConnector, CatalogueModel } from "../types/eroundProvisioning";

// eRound's connector codes in words; an unknown code is shown as it is.
const CONNECTOR_NAMES: Record<string, string> = {
  S_TYPE_2: "Type 2 socket",
  C_TYPE_2: "Type 2 cable",
  C_CCS_2: "CCS",
  C_CHADEMO: "CHAdeMO",
  S_TYPE_2_CEE_7_7: "Type 2 socket + Schuko",
  S_CEE_7_7: "Schuko",
};

const connector = (c: CatalogueConnector): string =>
  [
    c.current,
    c.connectorType ? CONNECTOR_NAMES[c.connectorType] ?? c.connectorType : null,
    c.maxPowerKw !== null ? `${Number(c.maxPowerKw.toFixed(1))} kW` : null,
    c.current === "AC" && c.phases ? `${c.phases}-phase` : null,
  ]
    .filter(Boolean)
    .join(" · ");

/** A model's charging points in words, identical ones counted: "2 × DC · CCS · 150 kW". */
export const connectorSummary = (model: CatalogueModel): string => {
  const counts = new Map<string, number>();
  model.connectors.forEach((c) => {
    const text = connector(c);
    counts.set(text, (counts.get(text) ?? 0) + 1);
  });
  if (counts.size === 0) return "No charging points listed";
  return Array.from(counts, ([text, n]) => (n > 1 ? `${n} × ${text}` : text)).join(", ");
};

/** Whether eRound marks the model fully integrated; anything else is worth a second look. */
export const isIntegrated = (model: CatalogueModel): boolean => model.integrationStatus === "FULLY_INTEGRATED";
